import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Box, Image } from '@chatterbug/aaron'

const StatItem = ({ icon, title, number, label, Divider }) => {
  // TODOS: move this component to UI?
  return (
    <Flex>
      {Divider && <Divider />}
      <Flex flexDirection="column">
        <Flex alignItems="center" mb={6}>
          <Image src={icon || null} mr={4} />
          <Box as="h4" variant="text.tinyTitle" color="black0">
            {title}
          </Box>
        </Flex>
        <Flex flexDirection="row" alignItems="center" flexWrap="wrap">
          <Box
            as="h4"
            variant="text.h4"
            color={number > 0 ? 'black0' : 'gray60'}
            mr={4}
          >
            {number}
          </Box>
          <Box
            mt="2px"
            variant="text.tinyTitle"
            color="gray60"
            sx={{ whiteSpace: 'nowrap' }}
          >
            {label}
          </Box>
        </Flex>
      </Flex>
    </Flex>
  )
}

StatItem.propTypes = {
  icon: PropTypes.any,
  number: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  Divider: PropTypes.func,
}

export default StatItem
